import React, { useEffect, Fragment, useState, useRef } from "react";
import Breadcrumb from "../../../../components/common/breadcrumb";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import { showToast } from "../../../../components/ToastifyNotification";
import { UncontrolledTooltip } from "reactstrap";
import {
  GetNursingStationById,
  UpdateNursingStation
} from "../../../../api/ipd/nursingStationAPI";
import {
  GetInvestigationCategoryById,
  UpdateInvestigationCategory
} from "../../../../api/diagnosis/master/investigationCategoryAPI";
import { GetDepartmentalSubSpecialities } from "../../../../api/diagnosis/master/departmentalSubSpecilityAPI";
import useKeyboardSubmit from "../../../../hooks/useKeyboardSubmit";
import useEnterNavigation from "../../../../hooks/useEnterNavigation";

// Validation schema using Yup
const schema = yup.object().shape({
  name: yup.string().required("Name is required"),
  departmentalSubSpecialityId: yup
    .string()
    .required("Department Sub Speciality is required"),
  printSrNo: yup.string().required("Print Sr No is required"),
  printSeperatePage: yup.string().required("Print Seperate Page is required")
});

const EditInvestigationCategory = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { id } = useParams();

  const [subSpeciality, setSubSpeciality] = useState([]);

  const { register, handleSubmit, setValue, formState: { errors } } = useForm({
    resolver: yupResolver(schema)
  });

  const fetchSubSpeciality = async () => {
    try {
      const res = await GetDepartmentalSubSpecialities();
      if (res.success) setSubSpeciality(res.data);
      else showToast("error", res.message);
    } catch (err) {
      showToast("error", err.message);
    }
  };

  const fetchData = async () => {
    try {
      const response = await GetInvestigationCategoryById(id); // Make sure login function returns token
      if (response.success) {
        Object.keys(response.data).forEach(key => {
          setValue(key, response.data[key]);
        });
      } else {
        // setError(response.message);
        showToast("error", response.message);
      }
    } catch (error) {
      // setError(error); // Handle login errors
      showToast("error", error);
    }
  };

  // Fetch existing data
  useEffect(
    () => {
      if (id) {
        fetchSubSpeciality().then(() => {
          fetchData();
        });
      }
    },
    [id, setValue]
  );

  const onSubmit = async data => {
    try {
      dispatch({ type: "LOADER_START" });

      const response = await UpdateInvestigationCategory(id, data);
      if (response.success) {
        showToast("success", response.message);
      } else {
        showToast("error", response.message);
      }
    } catch (error) {
      showToast("error", error);
    } finally {
      dispatch({ type: "LOADER_STOP" });
    }
  };

  const formRef = useRef(null);
  useKeyboardSubmit(handleSubmit, onSubmit);
  useEnterNavigation(formRef);

  return (
    <Fragment>
      <Breadcrumb
        parent="Investigation Category"
        title="Edit Investigation Category"
      />
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12">
            <div className="card">
              <div className="card-header">
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <h5>Edit Investigation Category</h5>
                  <Link to={`/diagnosis/master/investigation-category/list`}>
                    <button className="btn btn-primary" id="list">
                      List Investigation Category
                    </button>
                    <UncontrolledTooltip placement="top" target="list">
                      List Investigation Category
                    </UncontrolledTooltip>
                  </Link>
                </div>
              </div>
              <form
                ref={formRef}
                className="form theme-form"
                onSubmit={handleSubmit(onSubmit)}
              >
                <div className="card-body">
                  <div className="row">
                    <div className="col-6">
                      <div className="form-group">
                        <label htmlFor="name">Category Name</label>
                        <input
                          className="form-control"
                          id="name"
                          type="text"
                          placeholder="Category Name"
                          {...register("name")}
                        />
                        {errors.name &&
                          <p className="text-danger">
                            {errors.name.message}
                          </p>}
                      </div>
                    </div>
                    <div className="col-md-6 mb-3">
                      <label>Departmental Sub Speciality *</label>
                      <select
                        className="form-control"
                        {...register("departmentalSubSpecialityId")}
                      >
                        <option value="">Select Department</option>
                        {subSpeciality.map(item =>
                          <option key={item._id} value={item._id}>
                            {item.name}
                          </option>
                        )}
                      </select>
                      {errors.departmentalSubSpecialityId &&
                        <p className="text-danger">
                          {errors.departmentalSubSpecialityId.message}
                        </p>}
                    </div>
                    <div className="col-6">
                      <div className="form-group">
                        <label htmlFor="name">Print Sr No</label>
                        <input
                          className="form-control"
                          id="name"
                          type="number"
                          placeholder="Print Sr No"
                          {...register("printSrNo")}
                        />
                        {errors.printSrNo &&
                          <p className="text-danger">
                            {errors.printSrNo.message}
                          </p>}
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="form-group">
                        <label htmlFor="name">Print Seperate Page</label>
                        <input
                          className="form-control"
                          id="name"
                          type="number"
                          placeholder="Print Seperate Page"
                          {...register("printSeperatePage")}
                        />
                        {errors.printSeperatePage &&
                          <p className="text-danger">
                            {errors.printSeperatePage.message}
                          </p>}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-footer text-end">
                  <button className="btn btn-primary me-2" type="submit">
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default EditInvestigationCategory;
